import CircularProgress from '@mui/material/CircularProgress';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import StatsCard from '../StatsCard';
import { DEFAULT_LEARN_MORE_URL } from './constants';
import {
  CountContainerSx,
  getCountSx,
  LinkSx,
  ParenthesesSx,
  SpinnerSx,
  TitleTextSx
} from './styles';
import { UnsyncedCardProps } from './types';

const UnsyncedCard = (props: UnsyncedCardProps) => {
  const { 
    'data-testid': dataTestId, 
    unsyncedCount, 
    learnMoreUrl = DEFAULT_LEARN_MORE_URL,
    processing
  } = props;

  // Simple title with inline "learn more" link
  const titleWithLink = (
    <Typography sx={TitleTextSx} component="div">
      Unsynced Assets{' '}
      <Typography component="span" sx={ParenthesesSx} variant="inherit">
        (<Link
          href={learnMoreUrl}
          target="_blank"
          rel="noopener"
          sx={LinkSx}
        >
          learn more
        </Link>)
      </Typography>
    </Typography>
  );

  return (
    <StatsCard
      data-testid={dataTestId}
      title={titleWithLink}
      value={
        <Stack direction="row" sx={CountContainerSx}>
          <Typography sx={getCountSx(unsyncedCount)}>{unsyncedCount}</Typography>
          {processing && <CircularProgress sx={SpinnerSx} size="small" />}
        </Stack>
      }
    />
  );
};

export default UnsyncedCard; 
